module.exports = __webpack_public_path__ + "img/modal2@2x.96ccdf46.png";